<div class="input-wrapper m-datepicker">
  <input class="app-input date-picker" type="text" [(ngModel)]="value" [minDate]="minDate" [maxDate]="maxDate"
    [firstDayOfWeek]=7 [placeholder]="placeholder" name="d2" (ngModelChange)="update($event)" ngbDatepicker
    #d2="ngbDatepicker" [formControl]="control" [attr.aria-label]="attAriaLabel" [attr.data-date-id]="attrDateID"
    [class.app-error-border]="(control.invalid && control.touched)">
  <div class="input-group-append">
    <button class="" (focus)="focusHandler()" (click)="toggleD2()" type="button" tabindex="0" #butOpenCalendar>
      <i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/date-picker/date-picker.component.html